import BaseService from "../../../services/BaseService.ts";

const v2ApiName = 'TenantManagementServiceV2API';
const collectionPath = '/users';

/**
 * Record T&C acceptance for a user.
 * PATCH /v2/users/{id} with { "tc-accepted": true }
 * Authenticated call — Amplify's custom_header attaches the ID token.
 */
export const updateTermsAndConditions = async (id: string) => {

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const baseService = new BaseService(v2ApiName, collectionPath);
    const payload = {'tc-accepted': true};
    const response = await baseService.patch(id, payload);
    console.debug('UPDATE SERVICE TERMS RESPONSE: ', response);
    if (response.status === 204) {
        return 'success'
    } else {
        return 'failed'
    }
};
